import { useContext, useEffect } from "react";
import {
  ActionIcon,
  Box,
  Center,
  Image,
  useMantineColorScheme,
} from "@mantine/core";
import { ScreenContext } from "../api/screenContext";
import logo from "../assets/img/logo.png";
import { Screen } from "./Screen";
import { IconSun, IconMoon } from "@tabler/icons";
import { SocketContext } from "../api/socketContext";

export default function AppWrapper({ children }) {
  const { screen, setScreen } = useContext(ScreenContext);
  const { room } = useContext(SocketContext);
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();

  const Icon = colorScheme === "dark" ? IconSun : IconMoon;

  // useEffect(() => {
  //   if (room?.room && screen === "home") {
  //     setScreen("room");
  //   }
  // }, [room, screen]);

  return (
    <Center
      sx={{
        width: "100%",
        height: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        padding: "60px 20px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <Image
        src={logo}
        sx={{ maxWidth: "240px", width: "100%", marginBottom: "32px" }}
      />
      <Screen screen={screen} />
      <ActionIcon
        color="teal"
        onClick={() => toggleColorScheme()}
        aria-label="Toggle color scheme"
      >
        <Icon color="teal" />
      </ActionIcon>
    </Center>
  );
}
